var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}.b{fill:#fff;}.c{fill:#707070;}.d{fill:#002445;opacity:0.75;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 36) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 32,
    height: 32,
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1,1V31H31V1H1M0,0H32V32H0Z",
    transform: "translate(4 4)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(5 5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.483,1h0L0,1A1,1,0,0,1-1,0,1,1,0,0,1,0-1L8.483-1a1,1,0,0,1,0,2Z",
    transform: "translate(18 25.995) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,9.483a1,1,0,0,1-1-1L-1,0A1,1,0,0,1,0-1,1,1,0,0,1,1,0L1,8.482A1,1,0,0,1,0,9.483Z",
    transform: "translate(18 14.002) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon_back.9b32a917430681f23e6b87bcbe441826.svg";
export { ForwardRef as ReactComponent };